// Input.js
var Input = pc.createScript('input');
Input.attributes.add('isRadio', {type:'boolean', default:false});
Input.attributes.add('gfx',{type:'entity'});
Input.attributes.add('placeholder', { type : 'string' });
Input.attributes.add('type', {
    type: 'string',
    enum: [
        { 'Text': 'text' },
        { 'Email': 'email' },
        { 'Password': 'password' }
    ],
    default : 'text'
});
Input.attributes.add('fontSize', { type : 'number', default : 1 });
Input.attributes.add('padding', { type : 'number', default : 1 });
Input.attributes.add('scaleUnit', {
    type: 'string',
    enum: [
        { 'Viewport Width': 'vw' },
        { 'Viewport Height': 'vh' },
        { 'Pixel': 'px' }
    ],
    default : 'vw'
});
Input.attributes.add('color', { type : 'rgb' });
Input.attributes.add('fontFamily', { type : 'string', default : 'Arial, sans-serif' });
Input.attributes.add('storeValue', { type : 'boolean' });

Input.attributes.add('focusEntity', { type : 'entity' });

Input.prototype.initialize = function() {

    this.topMarge = 0;
    this.ratio = this.app.graphicsDevice.width / this.app.graphicsDevice.height;  
    this.app.on('responsiveHandler:resetStartconditions', this.resetStart, this);
    
    
    var url = new URL(window.top.location.href);
    var seed = url.searchParams.get('s');

    if(seed === null){
        if(this.app.graphicsDevice.maxPixelRatio > 2){
            this.topMarge = this.app.graphicsDevice.height/5;
        } else {
            this.topMarge = this.app.graphicsDevice.height/2 + this.app.graphicsDevice.height/8 - 17;
        }  
    } else {
        this.topMarge = this.app.graphicsDevice.height/2 + this.app.graphicsDevice.height/8 - 17;
        this.resetStart();
    }
    
    this.genButton = this.entity.parent.children[1];
    this.genElement = this.genButton.element;
    this.heightDiv = 6;
    this.leftMarge = 170;
    this.fixHeight = 0;
    //console.info(this.genElement.height);
    

    this.element = document.createElement('input');
    this.element.placeholder = this.placeholder;
    
    this.element.type = this.type;
    
    this.element.style.position = 'absolute';
    this.element.style.fontFamily = this.fontFamily;

    this.element.style.border = '0px';
    this.element.style.borderColor = 'ff0000';
    this.element.style.background = 'white';
   
    this.element.style.borderRadius = '16px';

    this.element.style.opacity = 0.35;

    if(this.isRadio){
        this.element.style.opacity = 0.0;
        };

    this.element.style.fontSize = this.fontSize; //+ this.scaleUnit;
    this.element.style.padding = this.padding + this.scaleUnit;
    this.element.style.boxSizing = 'border-box';

    if(this.app.graphicsDevice.width >= 3000){
        this.element.style.borderRadius = '40px';
        this.element.style.fontSize = '24px';
    }
    
    var color = 'rgb(' + (this.color.r * 255) + ', ' + (this.color.g * 255) + ', ' + (this.color.b * 255) + ')';
    this.element.style.color = color;
    
    this.element.style.outline = 'none';
    document.body.appendChild(this.element);
    
    //disable focus entity
    if(this.focusEntity){
        this.focusEntity.enabled = false;   
        
        this.element.onfocus = this.onFocus.bind(this);
        this.element.onblur = this.onBlur.bind(this);
    }
    
    this.element.onchange = this.onChange.bind(this);
    
    if(this.storeValue){
        var value = window.localStorage.getItem(this.entity._guid);
        
        if(value){
            this.setValue(window.localStorage.getItem(this.entity._guid));   
        }
    }
    if(seed !== null){
        this.setValue(seed);
        this.app.fire('hover:generatorTrigger');
    }
    
    this.updateStyle();

    this.on('state', function(self){
        if(this.entity.enabled){
            this.element.style.display = 'block'; 
        }else{
            this.element.style.display = 'none'; 
        }
    }, this);
    this.changeInputStart();
};

Input.prototype.resetStart = function() {

    // if(this.ratio < 0.65 || this.app.graphicsDevice.width < 615){
    //     if(this.app.graphicsDevice.maxPixelRatio > 2){
    //         this.topMarge = 64.5;
    //     } else {
    //         this.topMarge = 103;
    //     }
    // } else {
    //     this.topMarge = 48.5;
    // }
};

Input.prototype.onFocus = function() {
    this.focusEntity.enabled = true;
};

Input.prototype.onBlur = function() {
    this.focusEntity.enabled = false;
};

Input.prototype.onChange = function() {
    if(this.storeValue){
        window.localStorage.setItem(this.entity._guid, this.getValue());
    }
};

Input.prototype.changeInputStart = function(){
   // console.log('RESETINPUTSTART');
    this.heightDiv = 8;
    this.leftMarge = 180;
    this.fixHeight = 27;
};

Input.prototype.resetInput = function(){
    //console.log('RESETINPUT');
    this.heightDiv = 24;
    this.leftMarge = 145;
    this.fixHeight = 16;
};

Input.prototype.updateStyle = function() {
    //console.log('genButton: ' + this.genButton.getLocalPosition().y);
    // console.info(window.screen.pixelDepth);
    if(this.app.graphicsDevice.maxPixelRatio < 2 && this.app.graphicsDevice.width < 3000){
        var mpr = this.app.graphicsDevice.maxPixelRatio;
        this.element.style.height = this.genButton.element.height / mpr + 'px';
        this.element.style.width = this.genButton.element.width / mpr  + 'px';
        this.element.style.left = this.genButton.getLocalPosition().x / mpr  - parseInt(this.element.style.width,10) + 5  + 'px';
        this.element.style.top = (this.genButton.getLocalPosition().y * -1) / mpr  - parseInt(this.element.style.height,10) / 2   + 'px'; 
    } else if(this.app.graphicsDevice.maxPixelRatio >= 2){
        var fct = this.app.graphicsDevice.maxPixelRatio;
        this.element.style.height = this.genButton.element.height / fct + 'px';
        this.element.style.width = this.genButton.element.width / fct  + 'px';
        this.element.style.left = this.genButton.getLocalPosition().x / fct  - parseInt(this.element.style.width,10) + 5  + 'px';
        this.element.style.top = (this.genButton.getLocalPosition().y * -1) / fct  - parseInt(this.element.style.height,10) / 2   + 'px';  
    } else if(this.app.graphicsDevice.maxPixelRatio < 2 && this.app.graphicsDevice.width >= 3000){
        var pr = this.app.graphicsDevice.maxPixelRatio;
        this.element.style.borderRadius = '40px';
        this.element.style.fontSize = '24px';
        this.element.style.height = this.genButton.element.height / pr + 'px';
        this.element.style.width = this.genButton.element.width / pr  + 'px';
        this.element.style.left = this.genButton.getLocalPosition().x / pr  - parseInt(this.element.style.width,10) + 5  + 'px';
        this.element.style.top = (this.genButton.getLocalPosition().y * -1) / pr  - parseInt(this.element.style.height,10) / 2   + 'px'; 
    }
};

Input.prototype.changePosition = function(val){
    this.topMarge = val;
};


Input.prototype.update = function(dt) {
    this.updateStyle();
};

Input.prototype.setValue = function(val) {
    this.element.value = val;
};

Input.prototype.getValue = function() {
    if(this.element){
        return this.element.value;   
    }
};

